import script from "./WeChatContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatContainer.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatContainer.vue?vue&type=style&index=0&id=5d0e8cc8&lang=css"

const __exports__ = script;

export default __exports__